import * as React from 'react';
import {Fade, Grow, Slide, Zoom, useScrollTrigger } from '@mui/material';
import { transition } from '../services/app.service';

interface Props {
  id?: string;
  parentId?: string;
  type?: transition;
  addTime?: number;
  direction?:  'up'|'down'|'left'|'right' ;
  play?: boolean;
  window?: () => Window;
  children: React.ReactElement;
}


export const Transition: React.FunctionComponent<Props> = (props) => {
  
  const [play, setPlay] = React.useState(props.play);

  const hideOnScrollTrigger = useScrollTrigger({
    target: props.window ? props.window() : undefined,
    threshold: 10,
  });

  const hideOnScroll = () => {
    return (
      <Slide id={props.id} appear={false} direction={props.direction || 'up'}  in={!hideOnScrollTrigger} >
        {props.children}
      </Slide>
    )
  }   

  const slide = () => {
    return (
      <Slide id={props.id} direction={props.direction || 'up'} timeout={1000 + (props.addTime || 0)} in={play} mountOnEnter unmountOnExit>
        {props.children}
      </Slide>
    )
  }  
  
  const fade = () => {
    return (
      <Fade id={props.id} timeout={1000 + (props.addTime || 0)} in={play} mountOnEnter unmountOnExit>
        {props.children}
      </Fade>
    )
  }  
  
  const zoom = () => {
    return (
      <Zoom id={props.id} timeout={1000 + (props.addTime || 0)} in={play} mountOnEnter unmountOnExit>
        {props.children}
      </Zoom>
    )
  } 

  const grow = (from?: string) => {
    return (
      <Grow id={props.id} style={{ transformOrigin: from==='left'? '0 0 0': '' }} timeout={1000 + (props.addTime || 0)} in={play} mountOnEnter unmountOnExit>
        {props.children}
      </Grow>
    )
  }

  const onScroll = React.useCallback((e: Event) => { 
    const parent = document.getElementById(props.parentId || '') ;
    const parentPos = parent?.getBoundingClientRect();
    setPlay(parentPos? parentPos.top < window.innerHeight - 50 : true)
  }, [props.parentId]);

  React.useEffect(() => {
    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
    }
  }, [])

  React.useEffect(() => {
    if (props.play !== play)
      setPlay(props.play);

  }, [props.play])
  
  switch (props.type) {
    case 'hideOnScroll': return (hideOnScroll());
    case 'slide': return slide();
    case 'fade': return fade();
    case 'zoom': return zoom();
    case 'grow': return grow('');
    case 'growLeft': return grow('left');
    default : return <>{props.children}</>;
  }
  
}